import axios, { AxiosResponse } from '../../node_modules/axios/index';
import { getApiUrl } from '../constants/api';
import { Product } from '../types/product';
import { isFeatureEnabled } from '../utils/analytics';
import { handleCurrencyChange, getTaxWithRetry } from '../utils/calculate-tax';

export interface FbtParams {
  storeId: string;
  storeType: string;
  productId?: string;
  currency?: string;
}

interface Fbt {
  meta: any;
  results: Product[];
}

export async function getFrequentlyBoughtTogetherProducts({
  storeId,
  storeType,
  productId,
  currency,
}: FbtParams) {
  const sessionId = localStorage.getItem('alfinder_session_id');
  const headers =
    isFeatureEnabled('alfinder_customer_user') === true
      ? {
          'X-Alfinder-Session-Id': sessionId || '',
        }
      : {};
  console.log('[getFbt]', { sessionId, headers });

  const response: AxiosResponse<Fbt> = await axios.get(
    `${getApiUrl(
      storeId,
    )}/stores/${storeId}/recommendations/frequently-bought-together/bundle`,
    {
      params: {
        storeType,
        productId: productId ? productId : undefined,
      },
      headers,
    },
  );

  try {
    if (response.data.results.length > 0) {
      const currentCurrency = currency;
      handleCurrencyChange(currentCurrency as string);

      if (
        response.data.results[0] === null ||
        response.data.results[0] === undefined
      ) {
        return [];
      }

      // Get tax with retry logic
      const tax = await getTaxWithRetry(
        storeType,
        response.data.results[0].productId,
        response.data.results[0].price,
      );

      // If we couldn't get a valid tax after retries, return original data
      if (tax === null || isNaN(tax) || !isFinite(tax) || tax <= 0) {
        console.warn(
          'Could not calculate valid tax for FBT, returning original prices',
        );
        return response.data.results;
      }

      const updatedProducts = response.data.results.map((product) => {
        return {
          ...product,
          price: product.isTaxable ? product.price * tax : product.price,
          discountedPrice: product?.discountedPrice
            ? product.isTaxable
              ? product.discountedPrice * tax
              : product.discountedPrice
            : undefined,
        };
      });

      return updatedProducts;
    }

    return response.data.results;
  } catch (error) {
    console.error('Error processing product prices:', error);
    return response.data.results;
  }
}
